module.exports = __webpack_public_path__ + "media/images/webpage/hotels/93/plan1-1-71ed0055eda3170daed77daf9328c4f8.webp";